import { getAmountRounded } from './amountRounding'

const getAmount = (amount: number | string): number | string => {
    if (amount === '') {
        return amount
    }
    return getAmountRounded(amount)
}

export { getAmount }